import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

const HomePage = () => {
  const [user, setUser] = useState({});
  const [role, setRole] = useState('');

  const renderRole = (role) => {
    if (role === 'rnd') return 'R & D';
    else if (role === 'prod') return 'Produksi';
  };
  useEffect(() => {
    if (JSON.parse(Cookies.get('user')) == undefined) {
      Cookies.remove('user');
      Cookies.remove('token');
    } else {
      setUser(JSON.parse(Cookies.get('user')));
      setRole(user.role);
    }
  }, []);
  return (
    <div className="page-add mb-5">
      Selamat datang <span className="fw-bold">{user.nama}</span>, anda masuk
      sebagai bagian {role === 'prod' ? 'Produksi' : 'R&D'}
    </div>
  );
};

export default HomePage;
